import { combineReducers } from "redux"
import { number } from "./numberActiveReducer"

const numberActiveReducers = combineReducers({
    number
})

export default numberActiveReducers
